import React, { useState, useEffect } from 'react';
import { Table, Button, Row, Form, Col, Card, Badge } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import { Formik, Field, Form as FormikForm, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Ensure the DatePicker CSS is imported
import 'bootstrap/dist/css/bootstrap.min.css';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as moment from 'moment';
import { AccountCodeListAction } from '../../../../store/actions/AccountCodeActions';
import { getAccountCodeList } from '../../../../store/selectors/AccountCodeSelectors';
import { clearDatabase, retrieveData, storeData } from '../../../../services/indexedDBUtils';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import Swal from 'sweetalert2';
import { useLoader } from '../../../../context/LoaderCotext';
import ProjectCodesServices from '../../../../services/ProjectCodeService';
import { deleteFile } from '../../../../services/FileService';
import axiosInstance from '../../../../services/AxiosInstance';

const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

const VoucherForm = ({ profile, accountCodeList, employeeList }) => {
  const validationSchema = Yup.object({
    //submitter: Yup.string().required("Submitter name is required"),
    employee: Yup.object().required('Employee is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    employeeId: Yup.string().required('Employee Id is required'),
    date: Yup.date().required('Date is required'),
    products: Yup.array().of(
      Yup.object().shape({
        item_no: Yup.string().required('Item number is required'),
        account_code: Yup.object().required('Account code is required'),
        account_description: Yup.string().required('Account description is required'),
        project_code: Yup.object().required('Project code is required'),
        amount: Yup.string()
          .matches(
            /^\d+(\.\d{1,2})?$/,
            'Amount must be a valid decimal number with up to two decimal places'
          )
          .required('Amount is required'),
      })
    ),
    total: Yup.string()
      .matches(
        /^\d+(\.\d{1,2})?$/,
        'Total must be a valid decimal number with up to two decimal places'
      )
      .required('Total is required'),
    attachments: Yup.array()
      .min(
        1,
        'At least one file is required or selected file is not supporting, please select (jpeg, jpg, png, pdf).'
      ) // Ensures that at least one file is selected
      .of(
        Yup.mixed()
          .test(
            'fileType',
            'Unsupported file format, please select (jpeg, jpg, png, pdf).',
            (file) => {
              return file && SUPPORTED_FORMATS.includes(file.type);
            }
          )
          .test('fileSize', 'File is too large, please select smaller file', (file) => {
            return file && file.size <= 50000000; // Max file size of 5MB
          })
      )
      .required('Attachments are required'), // This ensures the array is not empty
  });
  const [submitterName, setSubmitterName] = useState('');
  const [uploadProgress, setUploadProgress] = useState({}); // To track progress for each file
  const [attachments, setAttachments] = useState([]);
  const initialValues = {
    submitter: submitterName,
    employee: '',
    email: '',
    employeeId: '',
    date: new Date(),
    products: [
      {
        item_no: 1,
        account_code: '',
        account_description: '',
        description: '',
        project_code: '',
        amount: 0,
      },
    ],
    total: 0,
    attachments: [],
    boxFolderId: '0',
    boxFolderName: 'Voucher-Forms',
    timestamp: moment().unix(),
  };

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [projectCodeList, setProjectCodeList] = useState([]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));

  useEffect(() => {
    dispatch(AccountCodeListAction());
    dispatch(employeeSearchAction(''));
    ProjectCodesServices.getProjectCode('')
      .then((response) => {
        // Ensure response and data exist and are valid
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          console.log('Invalid or empty project code data');
          setProjectCodeList([]);
          return; // Early return if no valid data
        }

        // Flatten and map project codes, with additional checks
        const codeList = response.data.flatMap(({ projectCodes }) =>
          Array.isArray(projectCodes) && projectCodes.length > 0
            ? projectCodes.map((code) => ({
                value: code,
                label: code,
              }))
            : []
        );

        // Update state with the final list of project codes, only if codeList is not empty
        if (codeList.length > 0) {
          setProjectCodeList(codeList);
        } else {
          console.log('No valid project codes found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching project codes:', error);
      });
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  const handleEmployeeChange = async (selectedOption, setFieldValue, values) => {
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`email`, '');
      setFieldValue(`employeeId`, '');
      setFieldValue(`boxFolderId`, '0');
      return false;
    }
    setFieldValue(`boxFolderId`, folderIdRes.folderId || '0');
    setFieldValue(`employeeId`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`email`, selectedOption.email);
    // values.products.map((product,index)=>{
    //   setFieldValue(`products[${index}].projectcode_code`,'')
    // });
    ProjectCodesServices.getProjectCode(selectedOption.employeeNumber || '')
      .then((response) => {
        // Ensure response and data exist and are valid
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          console.log('Invalid or empty project code data');
          setProjectCodeList([]);
          return; // Early return if no valid data
        }

        // Flatten and map project codes, with additional checks
        const codeList = response.data.flatMap(({ projectCodes }) =>
          Array.isArray(projectCodes) && projectCodes.length > 0
            ? projectCodes.map((code) => ({
                value: code,
                label: code,
              }))
            : []
        );

        // Update state with the final list of project codes, only if codeList is not empty
        if (codeList.length > 0) {
          setProjectCodeList(codeList);
        } else {
          console.log('No valid project codes found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching project codes:', error);
      });
  };

  const handleAccountCodeChange = (index, selectedOption, setFieldValue) => {
    setFieldValue(`products[${index}].account_code`, selectedOption);
    setFieldValue(`products[${index}].account_description`, selectedOption.accountDescription);
  };

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleFileChange = (event, setFieldValue, currentValues, setErrors) => {
    const files = Array.from(event.target.files);
    if (files.length <= 0) {
      setFieldValue('attachments', []);
      setAttachments([]);
    }

    // Validate the files before uploading them
    const validatedFiles = files.filter((file) => {
      const isValidType = SUPPORTED_FORMATS.includes(file.type);
      const isValidSize = file.size <= 5000000; // 5MB file size limit
      return isValidType && isValidSize;
    });

    if (validatedFiles.length === 0) {
      // If no valid files, set Formik error and prevent submission
      setErrors({
        attachments:
          'No valid files selected. Please upload valid files, please select (jpeg, jpg, png, pdf).',
      });
      return;
    }

    // Append new files to the existing array of files
    const updatedFiles = currentValues.attachments
      ? [...currentValues.attachments, ...files]
      : files;

    // Update Formik field value
    setFieldValue('attachments', updatedFiles);
    // Update the selected files state to include the new files
    setAttachments((prev) => [...prev, ...files]);
    // Upload each validated file
    validatedFiles.forEach(uploadFile);
  };

  // Remove a file from the attachments
  const handleRemoveFile = (index, setFieldValue, values, file) => {
    deleteFile(file.name)
      .then(() => {
        setAttachments((prevFiles) => prevFiles.filter((f) => f.name !== file.name));

        const newFiles = values.attachments.filter((_, i) => i !== index);
        setFieldValue('attachments', newFiles);
        // Clear the file input if no files are left
        if (newFiles.length === 0) {
          setFieldValue('attachments', []);
          setAttachments([]); // Clear the field as an empty array
        }

        setUploadProgress((prev) => {
          const newProgress = { ...prev };
          delete newProgress[file.name]; // Remove progress for the deleted file
          return newProgress;
        });
      })
      .catch((error) => {
        console.error('Error deleting file:', error);
      });
  };

  // Function to calculate total amount
  const calculateTotal = (products) => {
    const total = products.reduce((sum, product) => {
      return sum + (parseFloat(product.amount) || 0); // Calculate total
    }, 0);

    return Number(total.toFixed(2)); // Round to 2 decimal places
  };

  // Update total when products change
  const handleAmountChange = (index, amount, setFieldValue, values) => {
    const updatedProducts = [...values.products];
    updatedProducts[index].amount = amount; // Update amount
    const total = calculateTotal(updatedProducts); // Calculate new total
    setFieldValue(`products`, updatedProducts); // Update Formik state
    setFieldValue(`total`, total); // Update Formik total
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'voucher-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          height: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            height: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            height: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (
      typeof data != 'undefined' &&
      typeof data.products != 'undefined' &&
      data.products.length > 0
    ) {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        employee: data.employee.value,
        products: data.products.map((product) => {
          return {
            ...product,
            account_code: product.account_code.value,
            project_code: product.project_code.value,
          };
        }),
        attachments: attachments, // Send only the server-side filenames
      };
      handleUploadBatch(payloadForms);
    }
  };

  // Upload a single file
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('files', file); // Append the single file to FormData
    // Start upload for this specific file
    await axiosInstance
      .post('file/uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure the content type is set correctly
        },
        onUploadProgress: (progressEvent) => {
          // Safeguard to ensure total is not undefined
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            // Update the progress for this specific file using file.name
            setUploadProgress((prev) => ({
              ...prev,
              [file.name]: percentCompleted,
            }));
          }
        },
        timeout: 600000,
      })
      .then((response) => {
        const fileInfo = {
          name: response.data[0].fileName, // Get the server-generated name
          originalName: file.name, // Keep the original file name
        };
        setAttachments((prevFiles) => [
          ...prevFiles.filter((f) => f.name !== file.name), // Remove old entry if exists
          fileInfo, // Add new uploaded file info
        ]);
        setUploadProgress((prev) => ({
          ...prev,
          [file.name]: 100, // Set 100% progress after successful upload
        }));
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        // Optionally, handle the error state for the specific file
      });
  };

  return (
    <>
      <PageTitle pageTitle="Voucher Form" />
      <Card>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1678569052461"
          >
            Instruction to Submit the Voucher form
          </Link>
          <Link
            className="mb-2 text-primary"
            target="_blank"
            style={{ marginLeft: '40px' }}
            to="https://ssaihq.app.box.com/file/1648684002068"
          >
            Account Codes for Voucher
          </Link>
        </div>

        <Formik
          initialValues={{ ...initialValues, submitter: submitterName }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, setErrors, errors, touched }) => {
            return (
              <FormikForm>
                {/* Submitter and Employee Details */}
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Form Submitter</Form.Label>
                      <Field
                        as={Form.Control}
                        name="submitter"
                        placeholder="Enter Form Submitter"
                        value={submitterName}
                        readOnly
                      />
                      <ErrorMessage name="submitter" component="div" className="text-danger" />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Employee Name</Form.Label>
                      <AsyncSelect
                        cacheOptions
                        placeholder="Select employee..."
                        loadOptions={loadOptions}
                        defaultOptions={employeeList}
                        onChange={(option) => {
                          setFieldValue('employee', option);
                          handleEmployeeChange(option, setFieldValue, values);
                        }}
                        value={values.employee}
                      />
                      <ErrorMessage name="employee" component="div" className="text-danger" />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Employee Email</Form.Label>
                      <Field
                        as={Form.Control}
                        name="email"
                        type="email"
                        placeholder="Employee Email"
                        readOnly
                        value={values.email}
                      />
                      <ErrorMessage name="email" component="div" className="text-danger" />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Employee Id</Form.Label>
                      <Field
                        as={Form.Control}
                        name="employeeId"
                        type="text"
                        placeholder="Employee Id"
                        readOnly
                        value={values.employeeId}
                      />
                      <ErrorMessage name="employeeId" component="div" className="text-danger" />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Date</Form.Label>
                      <DatePicker
                        onChange={(date) => setFieldValue('date', date)}
                        selected={values.date}
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        minDate={new Date()}
                        placeholderText="MM-DD-YYYY"
                        className="form-control"
                      />
                      <ErrorMessage name="date" component="div" className="text-danger" />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Product Table */}
                <Row>
                  <Col md={12}>
                    <FieldArray name="products">
                      {({ push, remove }) => (
                        <>
                          <Table bordered hover id="tab_logic">
                            <thead>
                              <tr style={{ backgroundColor: '#eceef6' }}>
                                <th className="text-center"> No. </th>
                                <th className="text-center"> Account Code </th>
                                <th className="text-center"> ACCOUNT Description </th>
                                <th className="text-center"> Description </th>
                                <th className="text-center"> Project Code </th>
                                <th className="text-center"> Amount($) </th>
                                <th className="text-center"></th>
                              </tr>
                            </thead>

                            <tbody>
                              {values.products.map((product, index) => (
                                <tr key={index}>
                                  <td style={{ width: '1%' }}>{product.item_no}</td>

                                  <td>
                                    <Select
                                      name={`products[${index}].account_code`}
                                      options={accountCodeList}
                                      onChange={(option) =>
                                        handleAccountCodeChange(index, option, setFieldValue)
                                      }
                                      value={product.account_code}
                                    />
                                    <ErrorMessage
                                      name={`products[${index}].account_code`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>

                                  <td>
                                    <Field
                                      as={Form.Control}
                                      name={`products[${index}].account_description`}
                                      placeholder="Enter Account Description"
                                      value={product.account_description}
                                    />
                                    <ErrorMessage
                                      name={`products[${index}].account_description`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>

                                  <td>
                                    <Field
                                      as={Form.Control}
                                      name={`products[${index}].description`}
                                      placeholder="Enter Description"
                                      value={product.description}
                                    />
                                    <ErrorMessage
                                      name={`products[${index}].description`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>

                                  <td>
                                    <Select
                                      name={`products[${index}].project_code`}
                                      options={projectCodeList}
                                      value={product.project_code}
                                      onChange={(selectedOption) => {
                                        setFieldValue(
                                          `products[${index}].project_code`,
                                          selectedOption
                                        );
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`products[${index}].project_code`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>

                                  <td>
                                    <Field
                                      as={Form.Control}
                                      name={`products[${index}].amount`}
                                      type="text"
                                      placeholder="Amount"
                                      value={product.amount}
                                      onChange={(e) =>
                                        handleAmountChange(
                                          index,
                                          e.target.value,
                                          setFieldValue,
                                          values
                                        )
                                      }
                                    />
                                    <ErrorMessage
                                      name={`products[${index}].amount`}
                                      component="div"
                                      className="text-danger"
                                    />
                                  </td>

                                  <td className="text-center">
                                    {values.products.length > 1 && (
                                      <Button
                                        variant="danger"
                                        onClick={() => {
                                          remove(index); // Remove the item
                                          const updatedProducts = values.products.filter(
                                            (_, i) => i !== index
                                          ); // Get updated products without the removed item
                                          // Reassign item_no based on the new index
                                          const reassignedProducts = updatedProducts.map(
                                            (prod, i) => ({
                                              ...prod,
                                              item_no: i + 1,
                                            })
                                          );
                                          setFieldValue('products', reassignedProducts); // Update the Formik state

                                          const total = calculateTotal(reassignedProducts); // Calculate new total
                                          setFieldValue(`total`, total);
                                        }}
                                      >
                                        <i className="fa-solid fa-trash-can"></i>
                                      </Button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td colSpan={4}></td>
                                <td
                                  style={{
                                    textAlign: 'center',
                                    backgroundColor: '#eceef6',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      textTransform: 'uppercase',
                                      color: '#181c32',
                                    }}
                                  >
                                    Total Amount ($)
                                  </span>
                                </td>
                                <td colSpan={2} style={{ backgroundColor: '#eceef6' }}>
                                  <Field
                                    as={Form.Control}
                                    name={`total`}
                                    type="text"
                                    placeholder="Total"
                                    value={values.total}
                                    readOnly
                                  />
                                  <ErrorMessage
                                    name={`total`}
                                    component="div"
                                    className="text-danger"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          <Row>
                            <Col className="d-flex flex-column justify-content-start" md={6}>
                              <Form.Group>
                                <Form.Label htmlFor="custom-file">Choose File</Form.Label>
                                <Form.Control
                                  name={'attachments'}
                                  id="custom-file"
                                  type="file"
                                  multiple
                                  onChange={(e) =>
                                    handleFileChange(e, setFieldValue, values, setErrors)
                                  }
                                />
                                {/* Display validation errors from Yup */}
                                {errors.attachments && touched.attachments && (
                                  <div className="text-danger">
                                    {/* If it's an array, map over the errors */}
                                    {Array.isArray(errors.attachments) ? (
                                      errors.attachments.map((error, index) => (
                                        <div key={index}>{error}</div>
                                      ))
                                    ) : (
                                      /* If it's a string (e.g., "attachments is required"), display it directly */
                                      <div>{errors.attachments}</div>
                                    )}
                                  </div>
                                )}
                              </Form.Group>

                              {/* Display selected attachments */}
                              {values.attachments.length > 0 && (
                                <div className="mt-2">
                                  <strong>Selected Files:</strong>
                                  <Col md={8}>
                                    <ul>
                                      {attachments.map((file, index) => {
                                        const progressPercentage =
                                          (uploadProgress[file.name]
                                            ? uploadProgress[file.name]
                                            : uploadProgress[file.originalName]) || 0;

                                        return (
                                          <li
                                            key={file.name}
                                            style={{
                                              marginBottom: '10px',
                                              textAlign: 'left',
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                              }}
                                            >
                                              <div style={{ flexGrow: 1 }}>
                                                <strong>{file.originalName}</strong> -{' '}
                                                {progressPercentage}%
                                                <progress
                                                  value={progressPercentage}
                                                  max="100"
                                                  style={{
                                                    display: 'block',
                                                    width: '100%',
                                                    marginTop: '5px',
                                                  }} // Added margin for spacing
                                                />
                                              </div>
                                              <Badge
                                                style={{
                                                  marginLeft: '20px',
                                                  alignSelf: 'flex-start',
                                                }} // Align button properly
                                                variant="danger"
                                                size="sm"
                                                bg="danger"
                                                onClick={() =>
                                                  handleRemoveFile(
                                                    index,
                                                    setFieldValue,
                                                    values,
                                                    file
                                                  )
                                                }
                                                className="ml-2 mt-4"
                                              >
                                                <i className="fa fa-solid fa-close"></i>
                                              </Badge>
                                            </div>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </Col>
                                </div>
                              )}
                            </Col>

                            <Col
                              className="d-flex justify-content-end"
                              md={6}
                              style={{ paddingTop: '30px' }}
                            >
                              <Button
                                type="button"
                                variant="primary"
                                style={{
                                  height: 'max-content',
                                  marginRight: '10px',
                                }}
                                onClick={() =>
                                  push({
                                    item_no: values.products.length + 1,
                                    account_code: '',
                                    account_description: '',
                                    description: '',
                                    project_code: '',
                                    amount: 0,
                                  })
                                }
                              >
                                Add
                              </Button>
                              <Button
                                type="submit"
                                variant="success"
                                style={{ height: 'max-content' }}
                                className="ml-2"
                              >
                                Submit
                              </Button>
                            </Col>
                          </Row>
                        </>
                      )}
                    </FieldArray>
                  </Col>
                </Row>
              </FormikForm>
            );
          }}
        </Formik>
      </Card>
    </>
  );
};
const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
  accountCodeList: getAccountCodeList(state),
});

export default connect(mapStateToProps)(VoucherForm);
